import BarChart from './BarChart';

export default BarChart;

export interface BarChartProps {
  onClick?: (data: any) => void;
  onLoad: () => void;
  chartColors?: string[];
  chartLabels: string[];
  data: any[];
  chartKeys: string[];
  loading: boolean;
  isError?: boolean;
  emptyMessage?: string;
  withLegend?: boolean;
  chartLabelPosition?: 'top' | 'bottom';
  chartHeight?: number | string;
  chartWidth?: number | string;
}
